// SEO.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  publishedTime = '2025-05-01T00:00:00Z',
  author = "My Exam World",
  section = "Education",
  tags = ['online exam', 'exam platform', 'test series', 'live proctoring', 'performance analytics'],
  schema = null,
}) => {

  const siteTitle = "My Exam World";
  const pageDescription = description ? description : "My Exam World is a multilingual online exam platform where educators can create and share exams, and students can take them from any device. Features include test series, live proctoring, performance analytics, and mobile-friendly design — all in one seamless portal";
  const siteUrl = "https://www.myexamworld.com";
  const siteImage = "https://www.myexamworld.com/social-preview.webp";
  const authorName = author
  const keywordsList = keywords ? keywords : "online exam platform, multilingual tests, create online quizzes, live test portal, mobile exam app, test series platform, student result analysis, performance analytics, live exam proctoring, exam dashboard, MCQ test builder, online test creation, exam software, conduct exams online, secure testing system, educator tools, online assessment, custom test series, timed exams, subject-wise tests, competitive exam preparation, digital exam paper, adaptive quizzes, responsive exam layout, teacher exam portal, student practice tests, e-learning assessment, exam system for schools, real-time exam monitoring, result tracking, online education tools";

  const pageTitle = title ? title : siteTitle;
  const pageImage = image ? image : siteImage;
  const pageUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name='keywords' content={keywordsList} />
      <meta name="author" content={authorName} />

      {/* Canonical URL */}
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph metadata */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='630' />

      {/* Twitter Card metadata */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />

      {/* Article-specific metadata */}

      <meta property="article:published_time" content={publishedTime} />
      <meta property="article:author" content={author} />
      <meta property="article:section" content={section} />
      {tags && tags.map(tag => (
        <meta property="article:tag" content={tag} key={tag} />
      ))}

      {/* Dynamic JSON-LD Schema.org Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;